export const categoryDetailsController = {
  initial: 'off',
  states: {
    off: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'on',
          cond: 'isControllerEnabled_categoryDetails',
        },
      },
    },
    on: {
      type: 'parallel',
      states: {
        layoutReloader: {
          initial: 'reloading',
          states: {
            idle: {
              on: {
                RELOAD_CATEGORY_DETAILS: 'reloading',
                RELOAD_CATEGORIES: 'reloading',
              },
            },
            reloading: {
              invoke: {
                src: 'getCategoryDetailsLayoutContent',
                onDone: {
                  target: 'idle',
                  actions: [
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                  ],
                },
              },
            },
          },
        },
      },
      on: {
        LAYOUT_CHANGE_END: {
          target: 'off',
          cond: 'isControllerDisabled_categoryDetails',
        },
        VIEW_MODAL_BACK_BUTTON_CLICK: {
          actions: ['goBack'],
          target: 'off',
        },
      },
    },
  },
};
